














































import { Component, Prop, Vue } from 'vue-property-decorator';
import ICommand from '../interfaces/command';
import { request } from '@/graphql/request';
import UpdateUserPreferenceMutation from '@/graphql/mutations/updateUserPreference.gql';
import GetUserPreferenceQuery from '@/graphql/queries/getUserPreference.gql';

@Component({})
export default class HatsuiDataDisplay extends Vue {
  @Prop({ required: true })
  public data!: JSON;

  public hatsuiDataArray: string[] = [];
  public isAliasBeingChanged: boolean = false;
  public errorMessage = '';
  public i = 0;
  public aliases = [
    'ID',
    'S',
    'AX',
    'AY',
    'AZ',
    'DX',
    'DY',
    'DZ',
    'T1',
    'T2',
    'T3',
    'V1',
    'V2',
    'V3',
    'V4',
    'V5',
    'V6',
    'V7',
    'V8',
    'V9',
  ];

  public newAliases: string[] = this.aliases;

  public mounted() {
    this.fillAliases();
    this.parseHatsuiData();
  }

  public async fillAliases() {
    await request(GetUserPreferenceQuery as any, {
      key: 'hatsui_aliases',
    })
      .then(({ data, errors }) => {
        if (errors && errors.length && errors.length > 0) {
          throw new Error();
        }
        let aliases = data && data.getUserPreference && JSON.parse(data.getUserPreference);
        aliases = aliases || this.aliases;

        this.aliases = [...aliases, ...this.aliases.slice(aliases.length)];
        this.newAliases = this.aliases;
      })
      .catch((e: any) => {
        this.errorMessage = 'Could not find saved aliases';
      });
  }

  public parseHatsuiData() {
    const commandString = this.data.toString();

    this.hatsuiDataArray = commandString
      .substr(1, commandString.length - 2)
      .split(';')
      .map(data => isNaN(data as any) ? data : this.roundToDecimals(data, 7).toString());
  }

  public startChangeAlias() {
    this.isAliasBeingChanged = true;
  }

  public endChangeAlias() {
    this.isAliasBeingChanged = false;

    for (const alias in this.newAliases) {
      if (alias.length <= 0) {
        this.errorMessage = 'Alias cannot be empty.';
        return;
      }
    }

    request(UpdateUserPreferenceMutation as any, {
      key: 'hatsui_aliases',
      value: JSON.stringify(this.newAliases),
    })
      .then(({ data, errors }) => {
        if (errors && errors.length && errors.length > 0) {
          throw new Error();
        }
        this.aliases = this.newAliases;
      })
      .catch(error => {
        this.errorMessage = 'Alias change failed.';
      });
  }


  public roundToDecimals(num: number | string, decimals: number) {
      if (!num) {
        return num
      };

      return +((+num).toFixed(decimals));
  }
}
